import type { BuildingSocietyLoanConfig } from '../BuildingSocietyLoanConfig';

export const loan: BuildingSocietyLoanConfig = {
    overview: {
        highlights: {
            showInstallment: true,
            showBalance: true,
            showRepayments: false,
            showLoanAmount: false,
        },
        list: {
            showIbanAndBic: false,
            showLoanAmount: true,
            showNextInstallmentDate: true,
            showDebitInterestRate: true,
            showAdditionalInfo: true,
            showStartDate: false,
        },
    },
    settingsDetails: {
        showSlashedBBAN: true,
    },
};
